export default "__VITE_ASSET__a6a32cff__"